import React from 'react';
import clsx from 'clsx';
import styles from './SkeletonCard.scss';

interface SkeletonCardProps {
  className?: string;
  shimmer?: boolean;
  size?: string;
}

export function SkeletonCard({ className, shimmer = false, size }: SkeletonCardProps) {
  const style = size ? ({ '--skeleton-card-width': size } as React.CSSProperties) : undefined;

  return (
    <div className={clsx(styles.skeletonCard, shimmer && styles.shimmer, className)} style={style}>
      <div className={styles.imagePlaceholder} />

      <div className={styles.textContainer}>
        <div className={styles.textLine} />
        <div className={styles.textLineShort} />
      </div>
    </div>
  );
}
